var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChartHistogram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.73221 3.88783C4.73221 3.42244 4.35493 3.04517 3.88954 3.04517C3.42415 3.04517 3.04688 3.42244 3.04688 3.88783V16.3095C3.04686 18.1101 3.04684 19.5471 3.19836 20.6741C3.3549 21.8384 3.68692 22.7973 4.44547 23.5559C5.20403 24.3144 6.16288 24.6464 7.32718 24.803C8.4542 24.9545 9.89118 24.9545 11.6918 24.9545H24.1135C24.5789 24.9545 24.9562 24.5772 24.9562 24.1118C24.9562 23.6464 24.5789 23.2691 24.1135 23.2691H21.5855V15.1234C21.5855 14.658 21.2082 14.2807 20.7428 14.2807C20.2774 14.2807 19.9002 14.658 19.9002 15.1234V23.2691H15.9677L15.9677 11.7527C15.9677 11.2873 15.5905 10.91 15.1251 10.91C14.6597 10.91 14.2824 11.2873 14.2824 11.7527V23.2691H11.7544C11.229 23.2691 10.7469 23.269 10.3032 23.2658C10.3335 23.1789 10.35 23.0855 10.35 22.9882L10.35 15.1234C10.35 14.658 9.9727 14.2807 9.50731 14.2807C9.04191 14.2807 8.66464 14.658 8.66464 15.1234L8.66464 22.9882C8.66464 23.072 8.67687 23.153 8.69965 23.2294C8.27333 23.2091 7.89378 23.1786 7.55174 23.1327C6.57433 23.0013 6.03041 22.7574 5.63718 22.3641C5.24395 21.9709 5.00007 21.427 4.86866 20.4496C4.734 19.4479 4.73221 18.1245 4.73221 16.2469V3.88783Z",
    fill: "url(#paint0_linear_5178_10851)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6841 8.31931C16.3389 6.53032 13.9112 6.53032 12.5661 8.31931C11.6705 9.51041 10.5363 10.0172 9.38067 10.2189C8.52245 10.3687 7.59689 10.3538 6.77752 10.3406C6.5549 10.337 6.34011 10.3335 6.13665 10.3335H3.88954C3.42415 10.3335 3.04688 9.95626 3.04688 9.49087C3.04688 9.02548 3.42415 8.64821 3.88954 8.64821H6.13665C6.40282 8.64821 6.65896 8.65206 6.90693 8.6558C7.69772 8.6677 8.40545 8.67835 9.09084 8.5587C9.92686 8.41275 10.637 8.08052 11.219 7.30647C13.2384 4.62083 17.0117 4.62083 19.0311 7.30646C19.6131 8.08052 20.3233 8.41275 21.1593 8.5587C21.8447 8.67835 22.5524 8.6677 23.3432 8.6558C23.5912 8.65206 23.8473 8.64821 24.1135 8.64821C24.5789 8.64821 24.9562 9.02548 24.9562 9.49087C24.9562 9.95626 24.5789 10.3335 24.1135 10.3335C23.91 10.3335 23.6952 10.337 23.4726 10.3406C22.6532 10.3538 21.7277 10.3687 20.8695 10.2189C19.7138 10.0172 18.5797 9.51041 17.6841 8.31931Z",
    fill: "url(#paint1_linear_5178_10851)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5178_10851",
    x1: 14.0015,
    y1: 3.04517,
    x2: 14.0015,
    y2: 24.9545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C7BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#33F7BE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5178_10851",
    x1: 14.0015,
    y1: 5.29224,
    x2: 14.0015,
    y2: 10.3485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C7BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#33F7BE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartHistogram);
export default __webpack_public_path__ + "static/media/chart-histogram.a0f598705d5c1ce88a021f98079b8f9f.svg";
export { ForwardRef as ReactComponent };